module.exports = __webpack_public_path__ + "static/img/bg.4a0ab302.png";